
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SendCampaignDialog extends Serenity.EntityDialog<SendCampaignRow, any> {
        protected getFormKey() { return SendCampaignForm.formKey; }
        protected getIdProperty() { return SendCampaignRow.idProperty; }
        protected getLocalTextPrefix() { return SendCampaignRow.localTextPrefix; }
        protected getNameProperty() { return SendCampaignRow.nameProperty; }
        protected getService() { return SendCampaignService.baseUrl; }
        protected getDeletePermission() { return SendCampaignRow.deletePermission; }
        protected getInsertPermission() { return SendCampaignRow.insertPermission; }
        protected getUpdatePermission() { return SendCampaignRow.updatePermission; }

        protected form = new SendCampaignForm(this.idPrefix);
        constructor() {
            super();
            q.hideCategorylinks(this.element);
            this.form.ProviderId.changeSelect2(e => {
                var providerData = CampaignSetupRow.getLookup().itemById[this.form.ProviderId.value];
                this.form.ProviderType.value = providerData.Type.toString();
                var x = providerData.Type.toString();
                if (providerData.Type.toString() == "250" || providerData.Type.toString() == "253") {
                    q.showField(this.form.Message);
                    q.hideField(this.form.Title);
                    q.hideField(this.form.Image);
                    q.hideField(this.form.Html);
                    Serenity.EditorUtils.setRequired(this.form.Message, true);
                    Serenity.EditorUtils.setRequired(this.form.Title, false);
                    Serenity.EditorUtils.setRequired(this.form.Image, false);
                    Serenity.EditorUtils.setRequired(this.form.Html, false);
                } else if (providerData.Type.toString() == "252") {
                    q.showField(this.form.Message);
                    q.showField(this.form.Title);
                    q.showField(this.form.Image);
                    q.hideField(this.form.Html);
                    Serenity.EditorUtils.setRequired(this.form.Message, true);
                    Serenity.EditorUtils.setRequired(this.form.Title, true);
                    Serenity.EditorUtils.setRequired(this.form.Image, true);
                    Serenity.EditorUtils.setRequired(this.form.Html, false);
                } else if (providerData.Type.toString() == "251") {
                    q.hideField(this.form.Message);
                    q.showField(this.form.Title);
                    q.hideField(this.form.Image);
                    q.showField(this.form.Html);
                    Serenity.EditorUtils.setRequired(this.form.Message, false);
                    Serenity.EditorUtils.setRequired(this.form.Title, true);
                    Serenity.EditorUtils.setRequired(this.form.Image, false);
                    Serenity.EditorUtils.setRequired(this.form.Html, true);
                }

            });
            this.form.UseTemplate.changeSelect2(e => {
                if (this.form.UseTemplate.value) {
                    this.form.TemplateId.getGridField().toggle(true);
                    this.form.Message.getGridField().toggle(false);
                    this.form.Title.getGridField().toggle(false);
                    this.form.Image.getGridField().toggle(false);
                    this.form.Html.getGridField().toggle(false);
                } else {
                    this.form.TemplateId.getGridField().toggle(false);
                    this.form.Message.getGridField().toggle(true);
                    this.form.Title.getGridField().toggle(true);
                    this.form.Image.getGridField().toggle(true);
                    this.form.Html.getGridField().toggle(true);
                }
            });
            this.form.Schedule.changeSelect2(e => {
                if (this.form.Schedule.value.toString() == "Send") {
                    this.form.DateTime.getGridField().toggle(false);
                    this.form.Recurring.getGridField().toggle(false);
                } else if (this.form.Schedule.value.toString() == "Schedule") {
                    this.form.DateTime.getGridField().toggle(true);
                    this.form.Recurring.getGridField().toggle(true);
                }
                
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ProviderId.value != "") {
                if (!this.form.UseTemplate.value) {
                    q.hideField(this.form.TemplateId);
                    var providerData = CampaignSetupRow.getLookup().itemById[this.form.ProviderId.value];
                    this.form.ProviderType.value = providerData.Type.toString();
                    if (providerData.Type.toString() == "250" || providerData.Type.toString() == "253") {
                        q.showField(this.form.Message);
                        q.hideField(this.form.Title);
                        q.hideField(this.form.Image);
                        q.hideField(this.form.Html);
                        Serenity.EditorUtils.setRequired(this.form.Message, true);
                        Serenity.EditorUtils.setRequired(this.form.Title, false);
                        Serenity.EditorUtils.setRequired(this.form.Image, false);
                        Serenity.EditorUtils.setRequired(this.form.Html, false);
                    } else if (providerData.Type.toString() == "252") {
                        q.showField(this.form.Message);
                        q.showField(this.form.Title);
                        q.showField(this.form.Image);
                        q.hideField(this.form.Html);
                        Serenity.EditorUtils.setRequired(this.form.Message, true);
                        Serenity.EditorUtils.setRequired(this.form.Title, true);
                        Serenity.EditorUtils.setRequired(this.form.Image, true);
                        Serenity.EditorUtils.setRequired(this.form.Html, false);
                    } else if (providerData.Type.toString() == "251") {
                        q.hideField(this.form.Message);
                        q.showField(this.form.Title);
                        q.hideField(this.form.Image);
                        q.showField(this.form.Html);
                        Serenity.EditorUtils.setRequired(this.form.Message, false);
                        Serenity.EditorUtils.setRequired(this.form.Title, true);
                        Serenity.EditorUtils.setRequired(this.form.Image, false);
                        Serenity.EditorUtils.setRequired(this.form.Html, true);
                    }
                }
                
                if (this.form.Schedule.value.toString() == "Send") {
                    q.hideField(this.form.DateTime);
                    q.hideField(this.form.Recurring);
                } else if (this.form.Schedule.value.toString() == "Schedule") {
                    q.showField(this.form.DateTime);
                    q.showField(this.form.Recurring);
                }
            } else {
                q.hideField(this.form.Message);
                q.hideField(this.form.Title);
                q.hideField(this.form.Image);
                q.hideField(this.form.Html);
            }
        }
    }
}